import { useState } from 'react';
import { Button } from '@mui/material';
import {
  globalContractEmailPattern,
  initialGlobalContractFormValues,
} from '../../utils/contractsData';
import ConfirmModal from '../Layout/ConfirmModal';
import { InputTextField } from '../Input/InputTextField';
import ContractTermsModal from './ContractTermsModal';

const ApplyGlobalContractModal = ({ onAgree, onClose }) => {
  const [formValues, setFormValues] = useState(initialGlobalContractFormValues);
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [hasViewedTerms, setHasViewedTerms] = useState(false);

  const handleChange = (field) => (value) => {
    setFormValues((currentValues) => ({
      ...currentValues,
      [field]: value,
    }));
  };

  const handleSubmit = () => {
    onAgree?.({
      contactInfo: {
        name: formValues.contactName.trim(),
        email: formValues.contactEmail.trim(),
      },
      patientInfo: {
        firstName: formValues.patientFirstName.trim(),
        lastName: formValues.patientLastName.trim(),
        id: formValues.patientId.trim(),
        date: formValues.patientDate,
      },
    });
  };

  const handleViewTerms = () => {
    setHasViewedTerms(true);
    setShowTermsModal(true);
  };

  return (
    <>
      <ConfirmModal
        title="You are applying for this global contract"
        description=""
        confirmLabel="Agree"
        cancelLabel="Cancel"
        confirmDisabled={!hasViewedTerms}
        onConfirm={handleSubmit}
        onClose={onClose}
      >
        <fieldset className="global-contract-form__section">
          <legend className="global-contract-form__section-title">Contact Info</legend>
          <div className="global-contract-form__fields">
            <InputTextField
              title="Name"
              value={formValues.contactName}
              onChange={handleChange('contactName')}
              required
            />
            <InputTextField
              title="Email"
              type="email"
              pattern={globalContractEmailPattern}
              validationTitle="Enter a valid email address such as name@example.com"
              value={formValues.contactEmail}
              onChange={handleChange('contactEmail')}
              required
            />
          </div>
        </fieldset>

        <fieldset className="global-contract-form__section">
          <legend className="global-contract-form__section-title">Patient Info</legend>
          <div className="global-contract-form__fields">
            <InputTextField
              title="First Name"
              value={formValues.patientFirstName}
              onChange={handleChange('patientFirstName')}
              required
            />
            <InputTextField
              title="Last Name"
              value={formValues.patientLastName}
              onChange={handleChange('patientLastName')}
              required
            />
            <InputTextField
              title="ID"
              value={formValues.patientId}
              onChange={handleChange('patientId')}
              required
            />
            <InputTextField
              title="Date"
              type="date"
              value={formValues.patientDate}
              onChange={handleChange('patientDate')}
              required
            />
          </div>
        </fieldset>

        <div className="mt-3">
          <Button
            type="button"
            variant="text"
            size="small"
            onClick={handleViewTerms}
          >
            View terms and conditions
          </Button>
        </div>
      </ConfirmModal>

      {showTermsModal && (
        <ContractTermsModal onClose={() => setShowTermsModal(false)} />
      )}
    </>
  );
};

export default ApplyGlobalContractModal;
